import { createFileRoute, redirect } from "@tanstack/react-router";

/** @public */
export const Route = createFileRoute("/unsubscribe/")({
    beforeLoad: () => {
        throw redirect({ to: "/login" });
    },
});
